<header class="sub-page-layout__header dischargeStatus__header">
  <div class="dischargeStatus__header-text h2 h2--semi-bold">Discharge Statuses</div>
  <mat-slide-toggle
    class="dischargeStatus__active-toggle"
    [checked]="activeFilter === 'active'"
    color="primary"
    (change)="showInactiveChanges($event)"
  >
    <div *ngIf="activeFilter !== 'inactive'">Active</div>
    <div *ngIf="activeFilter === 'inactive'">Inactive</div>
  </mat-slide-toggle>
  <button mat-flat-button color="primary" class="dischargeStatus__add-item" (click)="uploadCodes()" *ngIf="!viewOnly">
    <mat-icon>file_upload</mat-icon> Upload Discharge Statuses
  </button>
  <button
    mat-flat-button
    color="primary"
    class="dischargeStatus__add-item"
    (click)="addDischargeStatus()"
    *ngIf="!viewOnly"
  >
    <mat-icon>add_circle_outline</mat-icon> Add Discharge Status
  </button>
</header>
<div *ngIf="dataSource && gridConfig" class="lib-grid__grid-container">
  <lib-grid [dataSource]="dataSource" [gridConfiguration]="gridConfig" skipLoadOnInit="true" loadAfterInit="true">
    <div class="">
      <h4>No Discharge Statuses Found.</h4>
    </div>
  </lib-grid>
</div>
<footer *ngIf="isImplementation" class="dischargeStatus__footer">
  <lib-button-loading color="primary" class="dischargeStatus__button" (clickEvent)="next()" id="nextButton"
    >Next
  </lib-button-loading>
</footer>
